const MIB = 1024 * 1024;

export const MAX_FEEDBACK_ATTACHMENTS = 3;
export const MAX_FEEDBACK_ATTACHMENT_BYTES = 10 * MIB;
export const MAX_FEEDBACK_ATTACHMENTS_TOTAL_BYTES = 25 * MIB;

const PROXY_BODY_HEADROOM_OVER_ATTACHMENT_TOTAL_BYTES = 7 * MIB;

export const PROXY_CLIENT_MAX_BODY_BYTES =
  MAX_FEEDBACK_ATTACHMENTS_TOTAL_BYTES + PROXY_BODY_HEADROOM_OVER_ATTACHMENT_TOTAL_BYTES;
